export interface ISelectOption<V = string | number | boolean | object, L extends string = string> {
    label: L;
    value: V;
    group?: string;
}
